import styled from "@emotion/styled";
import {
  AllCaps,
  Button,
  Callout,
  FlexRow,
  H2,
  Link,
  PlaceholderBlock,
  Text,
} from "atoms";
import { constants } from "config";
import { useLocation } from "react-router-dom";
import { useAuth } from "features/auth";

type Props = {
  animated: boolean;
};

function ReviewListPlaceholder({ animated }: Props) {
  const location = useLocation();
  const {
    user,
    roles: { isHugger },
  } = useAuth();

  return (
    <Reviews>
      <div>
        <FlexRow>
          <PlaceholderBlock
            width="50px"
            height="50px"
            circle
            animated={animated}
          />
          <PlaceholderBlock width="200px" height=".9em" animated={animated} />
        </FlexRow>
        <PlaceholderBlock width="90%" height=".9em" animated={animated} />
        <PlaceholderBlock width="85%" height=".9em" animated={animated} />
        <PlaceholderBlock width="87%" height=".9em" animated={animated} />
      </div>
      <div>
        <FlexRow>
          <PlaceholderBlock
            width="50px"
            height="50px"
            circle
            animated={animated}
          />
          <PlaceholderBlock width="200px" height=".9em" animated={animated} />
        </FlexRow>
        <PlaceholderBlock width="90%" height=".9em" animated={animated} />
        <PlaceholderBlock width="85%" height=".9em" animated={animated} />
        <PlaceholderBlock width="87%" height=".9em" animated={animated} />
      </div>
      <div>
        <FlexRow>
          <PlaceholderBlock
            width="50px"
            height="50px"
            circle
            animated={animated}
          />
          <PlaceholderBlock width="200px" height=".9em" animated={animated} />
        </FlexRow>
        <PlaceholderBlock width="90%" height=".9em" animated={animated} />
        <PlaceholderBlock width="85%" height=".9em" animated={animated} />
        <PlaceholderBlock width="87%" height=".9em" animated={animated} />
      </div>

      {!isHugger && (
        <GatedModal center>
          {!user ? (
            <>
              <H2>Thanks for visiting!</H2>
              <Text textAlign="center" bold>
                Connect a wallet to view more of this page.
              </Text>
              <Link to="/sign-in" state={{ from: location }} variant="primary">
                Connect a Wallet
              </Link>
            </>
          ) : (
            <>
              <H2>
                <AllCaps>Hug</AllCaps> Pass Required to&nbsp;See&nbsp;Reviews
              </H2>
              <Text textAlign="center">
                You need a <AllCaps>Hug</AllCaps> Pass to see reviews and access
                other premium features.
              </Text>
              <br />
              <Link href={constants.openseaURL} variant="primary">
                Buy on OpenSea
              </Link>
              <br />
              <Button size="xs" variant="blank">
                Connect a wallet containing a <AllCaps>Hug</AllCaps> Pass
              </Button>
            </>
          )}
        </GatedModal>
      )}
    </Reviews>
  );
}

const Reviews = styled.div(({ theme }) => ({
  gridArea: "reviews",
  position: "relative",
  display: "grid",
  gap: "3rem",
  marginBottom: "4rem",
  padding: "1rem",
  borderRadius: theme.borderRadius.md,
  backgroundColor: theme.colors.bg,
}));

const GatedModal = styled(Callout)(({ theme }) => ({
  boxShadow: theme.boxShadow.dark,
  position: "absolute",
  top: 0,
  left: "50%",
  transform: "translateX(-50%)",
  margin: "3rem 0",
  minHeight: 350,
  maxWidth: 666,
  width: "90%",
}));
export { ReviewListPlaceholder };
